<template>
	<div id="logs-todo-container" class="vs-con-loading__container comments">
		<div class="comments__list-item">
			<div v-for="(todo, idx) in todos" :key="`log-todo-${idx}`" class="pt-4  ">
				<a :href="relationItemLink(todo)" class="underline">
					<span v-if="JSON.parse(todo.properties)">
						<!-- San said, Mr.Man approved -->
						{{ JSON.parse(todo.properties) ? JSON.parse(todo.properties).start_date : "" | dateTime(userDateTimeFormat) }}
					</span>
					- {{ todo.name }}
				</a>
				<div class="flex items-center" v-if="relations && relations[0] && relations[0].type === 'Accessory' && todo.description != ''">
					<div v-html="todo.description"></div>
				</div>
				<div class="flex items-center" v-if="todo.forms && todo.forms.length > 0 && isSubmittedReportForms(todo.forms).length > 0">
					<p class="">{{ $t("Report") }}:</p>
					<div class="">
						<span class="report-form-content cursor-pointer" v-for="reportForm in isSubmittedReportForms(todo.forms)" :key="reportForm.id">
							<span class="nucleo nucleo-report-outline pt-2 mx-2" @click="setActiveForm(todo.forms, reportForm)"></span>
						</span>
					</div>
				</div>
			</div>

			<div class="text-center">
				<vs-button :disabled="loading" v-if="haveMore" id="button-logs-loading" class="list-item__btn-loadmore vs-con-loading__container" @click="loadMore">{{ $t("More") }}</vs-button>
			</div>
		</div>
		<vs-popup :title="`${$t('Report')} ${activeForm && activeForm.display_name}`" :active.sync="activePrompt" color="primary">
			<div class="con-exemple-prompt">
				<dynamic-form-content v-if="activeForm" :mappedAttachObj="mappedAttachFormObj(activeListForms)[activeForm.id]" :value="getParsedReportFormsDataContent(activeForm).controls || []" />
			</div>
		</vs-popup>
	</div>
</template>

<script>
import DynamicFormContent from "@/components/cbs-dynamic-form/DynamicFormContent.vue";
import * as _ from "lodash";
export default {
	name: "LogsTodoByRelations",
	components: { DynamicFormContent },
	props: {
		relations: {
			type: Array,
			default: () => []
		},
		limit: {
			type: Number,
			default: -1
		},
		statuses: {
			type: Array,
			default: () => []
		},
		logsType: {
			type: String,
			required: true
		},
		totalTodoList: {
			type: Number,
			default: 0
		},
		todos: {
			type: Array,
			default: () => []
		}
	},
	data() {
		return {
			page: 1,
			activeForm: null,
			activePrompt: false,
			activeListForms: [],
			loading: true
		};
	},
	computed: {
		totalPages() {
			return Math.ceil(this.totalTodoList / this.limit);
		},
		haveMore() {
			if (this.page <= this.totalPages) {
				return true;
			} else {
				return false;
			}
		}
	},
	methods: {
		relationItemLink(todo) {
			return `${this.$constant.PAGES_PATH.PAGE_CBS_TODO_PATH}?id=${todo.id}`;
		},

		loadMore() {
			this.$vs.loading({
				container: "#button-logs-loading",
				scale: 0.6
			});
			this.loading = true;
			const payload = {
				limit: this.limit,
				page: this.page,
				statuses: this.statuses,
				relations: this.relations,
				type: 0,
				orderBy: { column: "created_at", direction: "desc" },
				logsType: this.logsType
			};
			this.$emit("onLoadMoreLogsTodo", payload);
		},
		finishedLoadMore() {
			this.page = this.page + 1;
			this.loading = false;
			this.$vs.loading.close("#button-logs-loading > .con-vs-loading");
		},
		mappedAttachFormObj(forms) {
			const mappedAttachFormObj = {};
			(forms || []).forEach(form =>
				(form.attachs || []).forEach(attach => {
					mappedAttachFormObj[form.id] = mappedAttachFormObj[form.id] || {};
					mappedAttachFormObj[form.id][attach.id] = attach;
				})
			);
			return mappedAttachFormObj;
		},
		isSubmittedReportForms(forms) {
			return (forms || []).filter(reportForm => !!reportForm.is_submited);
		},
		setActiveForm(activeListForms, form) {
			this.activeListForms = activeListForms;
			this.activePrompt = true;
			this.activeForm = form;
		},
		getParsedReportFormsDataContent(form) {
			return this.$helper.formatDynamicFormData(_.cloneDeep(form), "properties", "data") || {};
		}
	}
};
</script>
